<section class="stacksBlockContainer staticContainer">
  <div id="settingsTabs" *ngIf="checkSettings()">
    <a (click)="showDataTab()" class="active">{{ 'Data' | translate }}</a>
  </div>
  <!-- Mobile Preview -->
  <div class="previewStatic previewMobile" *ngIf="checkPreview()" id="{{ 'blockid' + blockId }}" cdkDrag [cdkDragData]="blockId">
    <div class="blockControlHandlers" *ngIf="!builderService.globals">
      <div class="editBlock blockActionBtn" (click)="showData(blockId)">
        <mat-icon>edit</mat-icon>
      </div>
      <div class="blockHandle blockActionBtn" cdkDragHandle>
        <mat-icon>open_with</mat-icon>
      </div>
      <div class="deleteBlock blockActionBtn" *ngIf="getBlockFields(blockId).data?.deletable !== false" (click)="deleteBlock(blockId)">
        <mat-icon>close</mat-icon>
      </div>
    </div>
    <!-- <div class="blockPlaceholder" *cdkDragPlaceholder></div> -->
    <!-- <div *ngIf="getBlockFields(blockId).data.block == 'shop_filters'">
          <img src="../../../assets/images/views/components/{{getBlockFields(blockId).data.block}}" alt="">
      </div> -->
    <img *ngIf="getBlockFields(blockId).data && !getBlockFields(blockId).data?.variations && getBlockFields(blockId).data?.view !== 'shop'" src="../../../assets/images/views/components/{{ getBlockFields(blockId).data.view }}/{{ getBlockFields(blockId).data.block }}.png" alt="" />
    <img *ngIf="getBlockFields(blockId).data?.variations && getBlockFields(blockId).data?.view !== 'shop'" src="../../../assets/images/views/components/{{ getBlockFields(blockId).data.view }}/{{ getBlockFields(blockId).data?.variations[getBlockFields(blockId).style?.columns_number] }}.png" alt="" />
    <!-- Shop: show 0.png (3 cols default) or 1.png (2 cols) based on saved data.columns -->
    <img *ngIf="getBlockFields(blockId).data?.view === 'shop' && getBlockFields(blockId).data?.columns !== '2'" src="../../../assets/images/views/components/shop/products_list_3.png" alt="products_list" />
    <img *ngIf="getBlockFields(blockId).data?.view === 'shop' && getBlockFields(blockId).data?.columns === '2'" src="../../../assets/images/views/components/shop/products_list_2.png" alt="products_list" />
    <img
      *ngIf="getBlockFields(blockId).data?.variation_1"
      src="../../../assets/images/views/components/{{ getBlockFields(blockId).data.view }}/{{ getBlockFields(blockId).data?.variation_1[getBlockFields(blockId).style?.grid_list] }}_{{ getBlockFields(blockId).data.variation_2[getBlockFields(blockId).style?.columns_number] }}_{{
        getBlockFields(blockId).data.variation_3[getBlockFields(blockId).style?.products_style]
      }}.png"
      (error)="variationImageFallback($event, blockId)"
      alt=""
    />
  </div>
  <!-- Data and Style Tabs -->
  <div class="previewFields" *ngIf="checkData()">
    <mat-progress-bar mode="indeterminate" *ngIf="showProgress"></mat-progress-bar>
    <ul *ngIf="getBlockFields(blockId).data?.view == 'contact'">
      <li>
        <mat-label>{{ 'Recipient Email Address' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Email' | translate }}</mat-label>
          <input matInput type="email" (change)="queryChange('recipientEmail', blockId, $event, 'text')" [value]="getBlockFields(blockId).data?.recipientEmail || ''" [placeholder]="'contact@example.com' | translate" />
        </mat-form-field>
      </li>
      <li>
        <p class="helper-text">{{ 'Contact form submissions will be sent to this email address' | translate }}</p>
      </li>
    </ul>
    <ul *ngIf="getBlockFields(blockId).data?.view && getBlockFields(blockId).data?.block == 'single_image'">
      <li>
        <mat-label>{{ 'Single Product image behind header' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('header_place', blockId, $event, 'select')" value="{{ getBlockFields(blockId).style?.header_place ? getBlockFields(blockId).style?.header_place : 'imageBehindHeader' }}">
          <mat-option value="imageBehindHeader">
            {{ 'Behind Header' | translate }}
          </mat-option>
          <mat-option value="imageUnderHeader">
            {{ 'Under Header' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Image Dimensions' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('image_dimensions', blockId, $event, 'select')" value="{{ getBlockFields(blockId).style?.image_dimensions ? getBlockFields(blockId).style?.image_dimensions : 'landscape' }}">
          <mat-option value="landscape">
            {{ 'Landscape' | translate }}
          </mat-option>
          <mat-option value="portrait">
            {{ 'Portrait' | translate }}
          </mat-option>
        </mat-select>
      </li>
    </ul>
    <ul *ngIf="getBlockFields(blockId).data?.block == 'related_products'">
      <li>
        <mat-label>{{ 'Show Related Products' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('show_related_products', blockId, $event, 'select')" value="{{ getBlockFields(blockId).style?.show_related_products ? getBlockFields(blockId).style?.show_related_products : 'true' }}">
          <mat-option value="true">
            {{ 'Show' | translate }}
          </mat-option>
          <mat-option value="false">
            {{ 'Hide' | translate }}
          </mat-option>
        </mat-select>
      </li>
    </ul>
    <ul *ngIf="getBlockFields(blockId).data.block == 'singleblogpost'">
      <li>
        <mat-label>{{ 'Choose whether the required field is Phone or Email' | translate }}</mat-label>
      </li>
      <li>
        <mat-select (selectionChange)="queryChange('webview_or_native', blockId, $event, 'select')" value="{{ getBlockFields(blockId).data?.webview_or_native ? getBlockFields(blockId).data?.webview_or_native : 'native' }}">
          <mat-option value="native"> {{ 'Native' | translate }} </mat-option>
          <mat-option value="webview"> {{ 'Webview' | translate }} </mat-option>
        </mat-select>
      </li>
    </ul>

    <ul *ngIf="getBlockFields(blockId).data.block == 'signup'">
      <li>
        <mat-label>{{ 'Choose whether the required field is Phone or Email' | translate }}</mat-label>
      </li>
      <li>
        <mat-select (selectionChange)="queryChange('email_or_phone', blockId, $event, 'select')" value="{{ getBlockFields(blockId).data?.email_or_phone ? getBlockFields(blockId).data?.email_or_phone : 'email' }}">
          <mat-option value="email"> {{ 'Email' | translate }} </mat-option>
          <mat-option value="phone"> {{ 'Phone' | translate }} </mat-option>
        </mat-select>
      </li>
    </ul>
    <ul *ngIf="getBlockFields(blockId).data.view == 'cart'">
      <li>
        <mat-label>{{ 'Show Shipping Fee' | translate }}</mat-label>
        <mat-select (selectionChange)="queryChange('shippingFee', blockId, $event, 'select')" value="{{ getBlockFields(blockId).data?.shippingFee ? getBlockFields(blockId).data?.shippingFee : 'on' }}">
          <mat-option value="on"> {{ 'Show' | translate }} </mat-option>
          <mat-option value="off"> {{ 'Hide' | translate }} </mat-option>
        </mat-select>
      </li>
    </ul>
    <ul *ngIf="getBlockFields(blockId).data?.view == 'shop'">
      <li>
        <mat-label>{{ 'Product Columns' | translate }}</mat-label>
        <mat-select (selectionChange)="queryChange('columns', blockId, $event, 'select')" [value]="getBlockFields(blockId).data?.columns || '3'">
          <mat-option value="2">{{ '2 Columns (2 on Mobile)' | translate }}</mat-option>
          <mat-option value="3">{{ '3 Columns (2 on Mobile)' | translate }}</mat-option>
          <mat-option value="3f">{{ '3 Columns (Fixed)' | translate }}</mat-option>
          <mat-option value="4">{{ '4 Columns (3 on Mobile)' | translate }}</mat-option>
          <mat-option value="4-2">{{ '4 Columns (2 on Mobile)' | translate }}</mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Order By' | translate }}</mat-label>
        <mat-select (selectionChange)="queryChange('query_orderby', blockId, $event, 'select')" [value]="getBlockFields(blockId).data?.query_orderby || 'date'">
          <mat-option value="date">
            {{ 'Date' | translate }}
          </mat-option>
          <mat-option value="price">
            {{ 'Price' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Order' | translate }}</mat-label>
        <mat-select (selectionChange)="queryChange('query_order', blockId, $event, 'select')" [value]="getBlockFields(blockId).data?.query_order || 'DESC'">
          <mat-option value="ASC">
            {{ 'Ascendingly' | translate }}
          </mat-option>
          <mat-option value="DESC">
            {{ 'Descendingly' | translate }}
          </mat-option>
        </mat-select>
      </li>
    </ul>
    <ul *ngIf="getBlockFields(blockId).data.view == 'categories'">
      <li>
        <mat-label>{{ 'Categories Style' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.columns_number" (ngModelChange)="queryChange('columns_number', blockId, $event, 'select')">
          <mat-option value="oneColumn">
            {{ 'One Column' | translate }}
          </mat-option>
          <mat-option value="TwoColumns">
            {{ 'Two Columns' | translate }}
          </mat-option>
          <mat-option value="ThreeColumns">
            {{ 'Three Columns' | translate }}
          </mat-option>
          <mat-option value="List">
            {{ 'List' | translate }}
          </mat-option>
          <mat-option value="List2">
            {{ 'List 2' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Show Names' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('show_categories_names', blockId, $event, 'select')" value="{{ getBlockFields(blockId).style['show_categories_names'] }}">
          <mat-option value="yes">
            {{ 'Yes, Show Names' | translate }}
          </mat-option>
          <mat-option value="no">
            {{ 'No, Hide Names' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li *ngIf="getBlockFields(blockId).style?.show_categories_names !== 'no'">
        <mat-label>{{ 'Category Name Display' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('categories_name_overflow', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.categories_name_overflow || 'short'">
          <mat-option value="full">
            {{ 'Show Full Name' | translate }}
          </mat-option>
          <mat-option value="short">
            {{ 'Shorten long names (…)' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li *ngIf="getBlockFields(blockId).style?.show_categories_names !== 'no' && getBlockFields(blockId).style?.columns_number !== 'List' && getBlockFields(blockId).style?.columns_number !== 'List2'">
        <mat-label>{{ 'Category Name Position' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('categories_name_position', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.categories_name_position || 'overlay'">
          <mat-option value="overlay">
            {{ 'Inside Card' | translate }}
          </mat-option>
          <mat-option value="below">
            {{ 'Below Card' | translate }}
          </mat-option>
        </mat-select>
      </li>
    </ul>
    <ul *ngIf="getBlockFields(blockId).data.view == 'singleCategory'">
      <li>
        <mat-label>{{ 'Grid Style' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.grid_list" (ngModelChange)="queryChange('grid_list', blockId, $event, 'select')">
          <mat-option value="gridStyle">
            {{ 'Grid Style' | translate }}
          </mat-option>
          <mat-option value="listStyle">
            {{ 'List Style' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Number of Columns' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.columns_number" (ngModelChange)="queryChange('columns_number', blockId, $event, 'select')">
          <mat-option value="oneColumn">
            {{ 'One Column' | translate }}
          </mat-option>
          <mat-option value="twoColumns">
            {{ 'Two Columns' | translate }}
          </mat-option>
          <mat-option value="threeColumns">
            {{ 'Three Columns' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Products Shapes' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.products_style" (ngModelChange)="queryChange('products_style', blockId, $event, 'select')">
          <mat-option value="simpleStyle">
            {{ 'Simple Style' | translate }}
          </mat-option>
          <mat-option value="roundedStyle">
            {{ 'Rounded Style' | translate }}
          </mat-option>
          <mat-option value="glassStyle">
            {{ 'Glass Style' | translate }}
          </mat-option>
          <mat-option value="sharpStyle">
            {{ 'Sharp Style' | translate }}
          </mat-option>
          <mat-option value="cleanStyle">
            {{ 'Clean Style' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Add to Cart Visibility' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.cart_visibility" (ngModelChange)="queryChange('cart_visibility', blockId, $event, 'select')">
          <mat-option value="show_cart">
            {{ 'Show Cart' | translate }}
          </mat-option>
          <mat-option value="hide_cart">
            {{ 'Hide Cart' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Show Name' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('nameVisibility', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.nameVisibility || 'showName'">
          <mat-option value="hideName">
            {{ 'Hide Name' | translate }}
          </mat-option>
          <mat-option value="showName">
            {{ 'Show Name' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li *ngIf="(getBlockFields(blockId).style?.nameVisibility ?? 'showName') === 'showName'">
        <mat-label>{{ 'Product Name Display' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('nameOverflow', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.nameOverflow || 'short'">
          <mat-option value="full">
            {{ 'Show Full Name' | translate }}
          </mat-option>
          <mat-option value="short">
            {{ 'Shorten long names (…)' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Sort By' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.sort_by" (ngModelChange)="queryChange('sort_by', blockId, $event, 'select')">
          <mat-option value="date_asc">
            {{ 'Date Ascending' | translate }}
          </mat-option>
          <mat-option value="date_desc">
            {{ 'Date Descending' | translate }}
          </mat-option>
        </mat-select>
      </li>
    </ul>
    <ul *ngIf="getBlockFields(blockId).data.view == 'search' && getBlockFields(blockId).id === '6dd4-89a8'">
      <li>
        <mat-label>{{ 'Grid Style' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.grid_list" (ngModelChange)="queryChange('grid_list', blockId, $event, 'select')">
          <mat-option value="gridStyle">
            {{ 'Grid Style' | translate }}
          </mat-option>
          <mat-option value="listStyle">
            {{ 'List Style' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Number of Columns' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.columns_number" (ngModelChange)="queryChange('columns_number', blockId, $event, 'select')">
          <mat-option value="oneColumn">
            {{ 'One Column' | translate }}
          </mat-option>
          <mat-option value="twoColumns">
            {{ 'Two Columns' | translate }}
          </mat-option>
          <mat-option value="threeColumns">
            {{ 'Three Columns' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Products Shapes' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.products_style" (ngModelChange)="queryChange('products_style', blockId, $event, 'select')">
          <mat-option value="simpleStyle">
            {{ 'Simple Style' | translate }}
          </mat-option>
          <mat-option value="roundedStyle">
            {{ 'Rounded Style' | translate }}
          </mat-option>
          <mat-option value="glassStyle">
            {{ 'Glass Style' | translate }}
          </mat-option>
          <mat-option value="sharpStyle">
            {{ 'Sharp Style' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Add to Cart Visibility' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.cart_visibility" (ngModelChange)="queryChange('cart_visibility', blockId, $event, 'select')">
          <mat-option value="show_cart">
            {{ 'Show Cart' | translate }}
          </mat-option>
          <mat-option value="hide_cart">
            {{ 'Hide Cart' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Show Name' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.nameVisibility" (ngModelChange)="queryChange('nameVisibility', blockId, $event, 'select')">
          <mat-option value="hideName">
            {{ 'Hide Name' | translate }}
          </mat-option>
          <mat-option value="showName">
            {{ 'Show Name' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li *ngIf="(getBlockFields(blockId).style?.nameVisibility ?? 'showName') === 'showName'">
        <mat-label>{{ 'Product Name Display' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('nameOverflow', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.nameOverflow || 'short'">
          <mat-option value="full">
            {{ 'Show Full Name' | translate }}
          </mat-option>
          <mat-option value="short">
            {{ 'Shorten long names (…)' | translate }}
          </mat-option>
        </mat-select>
      </li>
    </ul>
    <ul *ngIf="getBlockFields(blockId).data.view == 'search' && getBlockFields(blockId).id === '6dd4-89a9'">
      <li>
        <mat-label>{{ 'Categories Style' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.columns_number" (ngModelChange)="queryChange('columns_number', blockId, $event, 'select')">
          <mat-option value="oneColumn">
            {{ 'One Column' | translate }}
          </mat-option>
          <mat-option value="TwoColumns">
            {{ 'Two Columns' | translate }}
          </mat-option>
          <mat-option value="ThreeColumns">
            {{ 'Three Columns' | translate }}
          </mat-option>
          <mat-option value="List">
            {{ 'List' | translate }}
          </mat-option>
          <mat-option value="List2">
            {{ 'List 2' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Show Names' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('show_categories_names', blockId, $event, 'select')" value="{{ getBlockFields(blockId).style['show_categories_names'] }}">
          <mat-option value="yes">
            {{ 'Yes, Show Names' | translate }}
          </mat-option>
          <mat-option value="no">
            {{ 'No, Hide Names' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li *ngIf="getBlockFields(blockId).style?.show_categories_names !== 'no'">
        <mat-label>{{ 'Category Name Display' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('categories_name_overflow', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.categories_name_overflow || 'short'">
          <mat-option value="full">
            {{ 'Show Full Name' | translate }}
          </mat-option>
          <mat-option value="short">
            {{ 'Shorten long names (…)' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li *ngIf="getBlockFields(blockId).style?.show_categories_names !== 'no' && getBlockFields(blockId).style?.columns_number !== 'List' && getBlockFields(blockId).style?.columns_number !== 'List2'">
        <mat-label>{{ 'Category Name Position' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('categories_name_position', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.categories_name_position || 'overlay'">
          <mat-option value="overlay">
            {{ 'Inside Card' | translate }}
          </mat-option>
          <mat-option value="below">
            {{ 'Below Card' | translate }}
          </mat-option>
        </mat-select>
      </li>
    </ul>
    <ul *ngIf="getBlockFields(blockId).id == '6dd4-90a9'">
      <li>
        <mat-label>{{ 'Grid Style' | translate }}</mat-label>
        <p class="gridStyleText">{{ 'Grid Style' | translate }}</p>
      </li>

      <li>
        <mat-label>{{ 'Number of Columns' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.columns_number" (ngModelChange)="queryChange('columns_number', blockId, $event, 'select')">
          <mat-option value="oneColumn">
            {{ 'One Column' | translate }}
          </mat-option>
          <mat-option value="twoColumns">
            {{ 'Two Columns' | translate }}
          </mat-option>
          <mat-option value="threeColumns">
            {{ 'Three Columns' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Products Shapes' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.products_style" (ngModelChange)="queryChange('products_style', blockId, $event, 'select')">
          <mat-option value="simpleStyle">
            {{ 'Simple Style' | translate }}
          </mat-option>
          <mat-option value="roundedStyle">
            {{ 'Rounded Style' | translate }}
          </mat-option>
          <mat-option value="glassStyle">
            {{ 'Glass Style' | translate }}
          </mat-option>
          <mat-option value="sharpStyle">
            {{ 'Sharp Style' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li>
        <mat-label>{{ 'Show Name' | translate }}</mat-label>
        <mat-select [(ngModel)]="getBlockFields(blockId).style.nameVisibility" (ngModelChange)="queryChange('nameVisibility', blockId, $event, 'select')">
          <mat-option value="hideName">
            {{ 'Hide Name' | translate }}
          </mat-option>
          <mat-option value="showName">
            {{ 'Show Name' | translate }}
          </mat-option>
        </mat-select>
      </li>
      <li *ngIf="(getBlockFields(blockId).style?.nameVisibility ?? 'showName') === 'showName'">
        <mat-label>{{ 'Product Name Display' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('nameOverflow', blockId, $event, 'select')" [value]="getBlockFields(blockId).style?.nameOverflow || 'short'">
          <mat-option value="full">
            {{ 'Show Full Name' | translate }}
          </mat-option>
          <mat-option value="short">
            {{ 'Shorten long names (…)' | translate }}
          </mat-option>
        </mat-select>
      </li>
    </ul>
    <div class="fieldsPanel" *ngIf="getBlockFields(blockId).data.view == 'checkout'">
      <!-- Provider-driven checkout fields (resolved from stacks-agents) -->
      <div class="fieldCard" *ngFor="let field of checkoutFields" [class.expanded]="isFieldExpanded(field.key)" [class.providerLocked]="!canEditCheckoutField(field)">
        <div class="fieldCardHeader" (click)="canEditCheckoutField(field) && toggleFieldExpansion(field.key)">
          <span class="fieldNameBtn">{{ field.label | translate }}</span>
          <div class="requiredGroup">
            <span class="requiredLabel">{{ 'Required' | translate }}</span>
            <label class="toggle-switch" (click)="$event.stopPropagation()">
              <input type="checkbox" [checked]="isCheckoutFieldRequired(blockId, field)" [disabled]="!canEditCheckoutField(field)" (change)="canEditCheckoutField(field) && queryChange(field.key + 'Required', blockId, { value: $any($event.target).checked ? 'on' : 'off' }, 'select')" />
              <span class="toggle-slider"></span>
            </label>
          </div>
          <button type="button" class="chevronBtn" [class.rotated]="isFieldExpanded(field.key)" aria-label="Toggle field" [disabled]="!canEditCheckoutField(field)">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </div>
        <div class="fieldConfig" *ngIf="isFieldExpanded(field.key)">
          <div class="fieldConfigRow">
            <span class="fieldConfigLabel">{{ 'Field State' | translate }}</span>
            <mat-select class="fieldConfigSelect" [disabled]="!canEditCheckoutField(field)" (selectionChange)="queryChange(field.key, blockId, $event, 'select')" [value]="getCheckoutFieldState(blockId, field)">
              <mat-option value="on">{{ 'Show' | translate }}</mat-option>
              <mat-option value="off">{{ 'Hide' | translate }}</mat-option>
            </mat-select>
          </div>
        </div>
      </div>

      <!-- Custom Fields List -->
      <ng-container *ngFor="let customField of getCustomFields(blockId); trackBy: trackByCustomFieldId">
        <div class="fieldCard customFieldCard" [class.expanded]="isFieldExpanded('custom_' + customField.id)">
          <div class="fieldCardHeader" (click)="toggleFieldExpansion('custom_' + customField.id)">
            <span class="fieldNameBtn">{{ customField.label || 'Custom Field' }}</span>
            <div class="requiredGroup">
              <span class="requiredLabel">{{ 'Required' | translate }}</span>
              <label class="toggle-switch" (click)="$event.stopPropagation()">
                <input type="checkbox" [checked]="customField.required === 'on'" (change)="updateCustomField(blockId, customField.id, 'required', $any($event.target).checked ? 'on' : 'off')" />
                <span class="toggle-slider"></span>
              </label>
            </div>
            <button type="button" class="chevronBtn" [class.rotated]="isFieldExpanded('custom_' + customField.id)" aria-label="Toggle field">
              <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
          </div>
          <div class="fieldConfig" *ngIf="isFieldExpanded('custom_' + customField.id)">
            <div class="fieldConfigRow fieldLabelRow">
              <span class="fieldConfigLabel">{{ 'Field Name' | translate }}</span>
              <input type="text" class="fieldLabelInput" [(ngModel)]="customField.label" (click)="$event.stopPropagation()" [placeholder]="'Enter field name' | translate" />
            </div>
            <div class="fieldConfigRow">
              <span class="fieldConfigLabel">{{ 'Field Type' | translate }}</span>
              <mat-select class="fieldConfigSelect" [value]="customField.type || 'text'" (selectionChange)="updateCustomField(blockId, customField.id, 'type', $event.value)">
                <mat-option value="text">{{ 'Text' | translate }}</mat-option>
                <mat-option value="email">{{ 'Email' | translate }}</mat-option>
                <mat-option value="number">{{ 'Number' | translate }}</mat-option>
                <mat-option value="tel">{{ 'Tel' | translate }}</mat-option>
              </mat-select>
            </div>
            <div class="fieldConfigRow">
              <span class="fieldConfigLabel">{{ 'Field State' | translate }}</span>
              <mat-select class="fieldConfigSelect" [value]="customField.show || 'on'" (selectionChange)="updateCustomField(blockId, customField.id, 'show', $event.value)">
                <mat-option value="on">{{ 'Show' | translate }}</mat-option>
                <mat-option value="off">{{ 'Hide' | translate }}</mat-option>
              </mat-select>
            </div>
            <button type="button" class="deleteFieldBtn" (click)="removeCustomField(blockId, customField.id); $event.stopPropagation()">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_3629_22948)">
                  <path
                    d="M8 3V2.6C8 2.03995 8 1.75992 7.89101 1.54601C7.79513 1.35785 7.64215 1.20487 7.45399 1.10899C7.24008 1 6.96005 1 6.4 1H5.6C5.03995 1 4.75992 1 4.54601 1.10899C4.35785 1.20487 4.20487 1.35785 4.10899 1.54601C4 1.75992 4 2.03995 4 2.6V3M5 5.75V8.25M7 5.75V8.25M1.5 3H10.5M9.5 3V8.6C9.5 9.44008 9.5 9.86012 9.33651 10.181C9.1927 10.4632 8.96323 10.6927 8.68099 10.8365C8.36012 11 7.94008 11 7.1 11H4.9C4.05992 11 3.63988 11 3.31901 10.8365C3.03677 10.6927 2.8073 10.4632 2.66349 10.181C2.5 9.86012 2.5 9.44008 2.5 8.6V3"
                    stroke="#FF383C"
                    stroke-width="1.2225"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3629_22948">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              {{ 'Delete Field' | translate }}
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Add Custom Field Button -->
      <button type="button" class="addFieldBtn" (click)="addCustomField(blockId)">
        <mat-icon>add</mat-icon>
        <span>{{ 'Add Custom Field' | translate }}</span>
      </button>
    </div>
    <div class="redirectToOption">
      <ul *ngIf="getBlockFields(blockId).data.block == 'signup'">
        <li>
          <mat-label> {{ 'Choose what page should the user redirect to after signing up' | translate }} </mat-label>
        </li>
        <li>
          <mat-select [(ngModel)]="selectedRedirect" (selectionChange)="onRedirectSelectionChange($event)" [value]="getBlockFields(blockId).data?.redirectTo || ''">
            <mat-option value="home">{{ 'Home' | translate }}</mat-option>
            <mat-option value="native-allcats">{{ 'All Products Categories' | translate }}</mat-option>
            <mat-option value="native-single-cat">{{ 'Product Category' | translate }}</mat-option>
            <mat-option value="profile">{{ 'Account Page' | translate }}</mat-option>
            <mat-option value="about">{{ 'About Us' | translate }}</mat-option>
          </mat-select>
        </li>
        <li *ngIf="selectedRedirect === 'native-single-cat' && builderService.standalone" class="productCategoryField">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Product Category' | translate }}</mat-label>
            <mat-select (selectionChange)="queryChange('categories', blockId, $event, 'select')" [value]="getBlockFields(blockId).data?.categories || ''">
              <mat-option *ngFor="let productCategory of standaloneCategoriesService.storedStandaloneCategories" [value]="productCategory.id">
                {{ productCategory.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </li>
      </ul>
    </div>
  </div>

  <div class="styleFields" *ngIf="checkStyle()">
    <ul *ngIf="getBlockFields(blockId).data?.view == 'categories'">
      <li>
        <mat-label>{{ 'Columns Number' | translate }}</mat-label>
        <mat-select (selectionChange)="styleChange('columns_number', blockId, $event, 'select')" value="{{ getBlockFields(blockId).style?.columns_number ? getBlockFields(blockId).style?.columns_number : 'oneColumn' }}">
          <mat-option value="oneColumn">
            {{ 'One Column' | translate }}
          </mat-option>
          <mat-option value="TwoColumns">
            {{ 'Two Columns' | translate }}
          </mat-option>
          <mat-option value="List"> {{ 'List' | translate }} </mat-option>
          <mat-option value="List2">
            {{ 'List 2' | translate }}
          </mat-option>
        </mat-select>
      </li>
    </ul>
  </div>
</section>
